<template>
  <div>
    <wt-radio-box
      v-for="date in dateOptions"
      :key="date.value"
      group="date-options-group"
      :selected="isDateSelected(date.value)"
      :value="date.value"
      :labelRight="date.label"
      @select="dateChanged"
    />
    <div class="wt2-radio-box-component" ref="customDateRow">
      <input
        type="radio"
        name="date-options-group"
        id="customDateRow"
        :checked="isCustomDateSelected"
      />
      <label
        for="customDateRow"
        class="-body"
        @click="customDateClicked"
      ></label>
      <div @click="customDateClicked">
        <wt-date-picker
          ref="datePicker"
          class="-date-picker"
          range
          :value="customValue"
          @change="customDateSelected"
          :not-after="todayDate"
          :shortcuts="false"
          :editable="false"
          format="MM/DD/YYYY"
          range-separator="-"
          width="200"
          input-class="-date-picker-input"
        />
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  data() {
    return {
      dateOptions: [
        {
          label: 'Any',
          value: null,
        },
        {
          label: 'Last 24 hours',
          value: 1,
        },
        {
          label: 'Last 7 days',
          value: 7,
        },
        {
          label: 'Last 30 days',
          value: 30,
        },
      ],
    };
  },

  analytics: {
    filterByDate: 'Filter By Date',
  },

  computed: Object.assign(
    {
      dateRange() {
        return this.contextFilters.dateRange;
      },
      customStartDate() {
        if (_.isArray(this.dateRange.customDates)) {
          return this.dateRange.customDates[0];
        } else {
          return null;
        }
      },
      customEndDate() {
        if (_.isArray(this.dateRange.customDates)) {
          return this.dateRange.customDates[1];
        } else {
          return null;
        }
      },
      isCustomDateSelected() {
        return (
          _.isArray(this.dateRange.dateSearch) ||
          this.dateRange.dateSearch === -1
        );
      },
      todayDate() {
        return new Date();
      },
      customValue() {
        if (!_.isArray(this.dateRange.customDates)) {
          return false;
        }
        return [
          app.moment(this.customStartDate).format('MM/DD/YYYY'),
          app.moment(this.customEndDate).format('MM/DD/YYYY'),
        ];
      },
    },
    app.Vuex.mapGetters(['contextFilters'])
  ),

  methods: Object.assign(
    {
      fixDatePickerPosition(e) {
        const $dpEl = this.$refs.datePicker.$el.getElementsByClassName(
          'mx-datepicker-popup'
        )[0];

        const dpHeight = $dpEl.clientHeight;
        const clickOffsetY = e.clientY;
        const docHeight = document.body.scrollHeight;
        const dateRowOffsetY =
          this.$refs.customDateRow.getBoundingClientRect().top;
        const dateRowHeight = this.$refs.customDateRow.clientHeight;

        if (clickOffsetY + dpHeight >= docHeight) {
          $dpEl.style.bottom = docHeight - dateRowOffsetY + 'px';
        } else {
          $dpEl.style.bottom =
            docHeight - dateRowOffsetY - dpHeight - dateRowHeight + 'px';
        }
      },

      formatDate(date, time) {
        return app.moment(date).format('MM/DD/YYYY') + ' ' + time;
      },

      isDateSelected(dateVal) {
        return this.contextFilters.dateRange.dateSearch === dateVal;
      },

      dateChanged(value) {
        this.SET_DATE_SELECTION({
          dateSearch: value,
          customDates:
            this.customStartDate || this.customEndDate
              ? [this.customStartDate, this.customEndDate]
              : null,
        });

        let since;

        switch (value) {
          case 1:
            since = 'day';
            break;
          case 7:
            since = 'week';
            break;
          case 30:
            since = 'month';
            break;
          default:
            since = 'any';
        }

        this.$triggerAnalytics('filterByDate', { since });

        this.SEARCH_ASSETS();
      },

      customDateClicked(e) {
        if (
          this.isCustomDateSelected ||
          $(e.target).parents().hasClass('mx-datepicker-popup')
        ) {
          return;
        }

        // this.$refs.datePicker.$el.click();
        this.$nextTick(() => {
          this.$refs.datePicker.open();
          this.$nextTick(() => {
            this.fixDatePickerPosition(e);
          });
        });
        const datesFromDatePicker =
          // is there any value in the date picker
          this.$refs.datePicker.$attrs.value &&
          // is the value have map function (a.k.a is an array)
          this.$refs.datePicker.$attrs.value.map &&
          // map the value (date string with DD/MM/YY format) to Date object
          this.$refs.datePicker.$attrs.value.map((date) => new Date(date));
        this.customDateSelected(datesFromDatePicker);
      },

      customDateSelected(dates) {
        if (dates && dates.length) {
          const customStart = Date.parse(this.formatDate(dates[0], '00:00:00'));
          const customEnd = Date.parse(this.formatDate(dates[1], '23:59:59'));
          const customDates = [customStart, customEnd];

          this.SET_DATE_SELECTION({
            dateSearch: customDates,
            customDates: customDates,
          });
        } else {
          this.SET_DATE_SELECTION({
            dateSearch: -1,
            customDates:
              this.customStartDate || this.customEndDate
                ? [this.customStartDate, this.customEndDate]
                : null,
          });
        }
        this.$triggerAnalytics('filterByDate', { since: 'custom' });
        this.SEARCH_ASSETS();
      },

      resetCustomDates() {
        this.customValue = '';
      },
    },
    app.Vuex.mapActions(['SET_DATE_SELECTION', 'SEARCH_ASSETS'])
  ),
};
</script>
